'use client';
import { REGEXP_ONLY_DIGITS } from 'input-otp';
import { Controller, useFormContext } from 'react-hook-form';
import { cn } from '../../utils';
import type { InputProps } from '../ui';
import {
  InputOTP,
  InputOTPGroup,
  InputOTPSeparator,
  InputOTPSlot,
} from '../ui/otp-input';
import { FormControl } from './FormControl';

export function FormOTPInput({
  name,
  label,
  className,
  ...props
}: {
  name: string;
  label: string;
  className?: string;
  maxLength: number;
  pattern?: typeof REGEXP_ONLY_DIGITS;
  separator?: string;
} & InputProps) {
  const { getValues, formState, setValue } = useFormContext();

  return (
    <FormControl label={label} name={name}>
      <Controller
        name={name}
        render={({ field }) => (
          <InputOTP
            {...field}
            disabled={
              props.disabled || formState.isSubmitting || field.disabled
            }
            className={cn('w-full', className)}
            maxLength={6}
            pattern={REGEXP_ONLY_DIGITS}
            inputMode="numeric"
            onComplete={(otp) => {
              console.log('otp', otp);
            }}
          >
            <InputOTPGroup>
              <InputOTPSlot index={0} />
              <InputOTPSlot index={1} />
              <InputOTPSlot index={2} />
            </InputOTPGroup>
            <InputOTPSeparator />
            <InputOTPGroup>
              <InputOTPSlot index={3} />
              <InputOTPSlot index={4} />
              <InputOTPSlot index={5} />
            </InputOTPGroup>
          </InputOTP>
        )}
      />
    </FormControl>
  );
}
